export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fare clic per selezionare quali colonne visualizzare"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Colonne visualizzate"])}
}